// extracted by mini-css-extract-plugin
export var banner = "_q4-0";
export var settingRow = "_q4-2";
export var titleIcon = "_q4-1";